"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineOfCoverageTypesPickerInput = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var uniq_1 = __importDefault(require("lodash/uniq"));
var react_1 = __importDefault(require("react"));
var definitions_1 = require("../../hooks/definitions");
var line_of_coverage_types_1 = require("../../hooks/line-of-coverage-types");
var line_of_coverage_type_option_1 = require("../../utils/line-of-coverage-type-option");
var add_line_of_coverage_type_1 = require("../add-line-of-coverage-type");
function LineOfCoverageTypesPickerInput(_a) {
    var selectedOptions = _a.value, policyType = _a.policyType, selectOptions = _a.onChange, enableAdditions = _a.enableAdditions, disableRepeated = _a.disableRepeated, selectAllByDefault = _a.selectAllByDefault;
    var _b = line_of_coverage_types_1.useLineOfCoverageOptions({
        policyType: policyType,
        selectAllByDefault: selectAllByDefault,
        selectedOptions: selectedOptions,
        selectOptions: selectOptions,
    }), options = _b.options, addOption = _b.addOption, selectOption = _b.selectOption, unselectOption = _b.unselectOption;
    var _c = definitions_1.useDefinitionsHelpers(), renderLineOfCoverageType = _c.renderLineOfCoverageType, renderPolicyType = _c.renderPolicyType, loading = _c.loading;
    // Handle the option being enabled/disabled
    function onCheckboxClick(option) {
        return function (isActive) {
            if (isActive) {
                selectOption(option);
            }
            else {
                unselectOption(option);
            }
        };
    }
    return (react_1.default.createElement(core_ui_1.Stack, { gap: 4, direction: "vertical" },
        options.length === 0 && (react_1.default.createElement(core_ui_1.Box, { backgroundColor: core_ui_1.colors.steel[50], style: { height: 48, display: 'flex', justifyContent: 'center', alignItems: 'center' } }, loading ? (react_1.default.createElement(core_ui_1.Spinner, { relative: true })) : (react_1.default.createElement(core_ui_1.Text, null,
            "No lines of coverage available for ",
            renderPolicyType(policyType))))),
        options.map(function (option) { return (react_1.default.createElement(core_ui_1.CheckboxRow, { key: policyType + "-" + option.id + "-checkbox", label: line_of_coverage_type_option_1.getOptionLabel(option, renderLineOfCoverageType), isActive: !!selectedOptions.find(function (_a) {
                var id = _a.id;
                return id === option.id;
            }), onClick: onCheckboxClick(option) })); }),
        enableAdditions && (react_1.default.createElement(add_line_of_coverage_type_1.AddLineOfCoverageType, { onSubmit: addOption, blacklist: disableRepeated ? uniq_1.default(line_of_coverage_type_option_1.optionsToTypes(options)) : [] }))));
}
exports.LineOfCoverageTypesPickerInput = LineOfCoverageTypesPickerInput;
